"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OR = exports.OPEN_BRACKET = exports.NOT = exports.CLOSE_BRACKET = exports.AND = void 0;
var OR = exports.OR = '|';
var AND = exports.AND = '&';
var NOT = exports.NOT = '^';
var OPEN_BRACKET = exports.OPEN_BRACKET = '(';
var CLOSE_BRACKET = exports.CLOSE_BRACKET = ')';